module.exports = __webpack_public_path__ + "472d1ab5f2668975c76bc6c5e7202c22.fbx";